// Angular imports
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// 3rd party module
import {
    DxBoxModule,
    DxButtonModule,
    DxLoadPanelModule,
    DxResponsiveBoxModule,
    DxDropDownBoxModule,
    DxDataGridModule,
    DxContextMenuModule,
    DxValidationGroupModule,
    DxValidatorModule,
    DxRadioGroupModule,
    DxTextBoxModule,
    DxTemplateModule,
    DxCheckBoxModule,
    DxDateBoxModule,
    DxSelectBoxModule,
    DxSwitchModule,
    DxPopupModule,
    DxScrollViewModule,
    DxNumberBoxModule,
    DxTextAreaModule,
    DxFileUploaderModule,
    DxDropDownButtonModule,
    DxFormModule,
    DxListModule,
    DxTooltipModule,
    DxChartModule,
    DxPopoverModule,
    DxTabsModule,
    DxTabPanelModule,
    DxToolbarModule
} from 'devextreme-angular';
import { AngularSplitModule } from 'angular-split';

// CC-Common imports
import { CCCommonModule, CCDataGridFeaturesModule } from 'cc-common';

// Module imports
import { ManagementCommonModule } from '../management-common/management-common.module';
import { VendorModule } from '../vendor/vendor.module';
import { SharedModule } from '../shared-module/shared.module';
import { SharedWorkflowModule } from '../shared-workflow-module/shared-workflow.module';
import { WorkflowRoutingModule } from './workflow-routing.module';
import { SharedCirabooksModule } from '../cirabooks/shared-cirabooks-module/shared-cirabooks.module';
import { SharedVendorManagementModule } from '../vendor-management/shared-vendor-management-module/shared-vendor-management.module';
import { WorkOrderMainModule } from '../work-orders-module/components/work-order/work-order-main.module';
import { WorkflowPaymentRequestModule } from '../workflow-payment-request-module/workflow-payment-request-module';

// Component imports
import { WorkflowEditorComponent } from './components/workflow-editor/workflow-editor.component';
import { WorkflowDataEntryComponent } from './components/workflow-data-entry/workflow-data-entry.component';
import { WorkflowDataEntryVendorNotesViewerComponent } from './components/workflow-data-entry-vendor-notes-viewer/workflow-data-entry-vendor-notes-viewer.component';
import { WorkflowSearchComponent } from './components/workflow-search/workflow-search.component';
import { ManageWorkflowVendorEditComponent } from './components/manage-workflow-vendor-edit/manage-workflow-vendor-edit.component';
import { WorkflowVendorEditEditorComponent } from './components/manage-workflow-vendor-edit/workflow-vendor-edit-editor/workflow-vendor-edit-editor.component';
import { WorkflowDeleteComponent } from './components/workflow-delete/workflow-delete.component';
import { WorkflowQueueDataGridComponent } from './components/workflow-queue-datagrid/workflow-queue-datagrid.component';
import { WorkflowDashboardComponent } from './components/workflow-dashboard/workflow-dashboard.component';
import { WorkflowQueueComponent } from './components/workflow-queue/workflow-queue.component';
import { WorkflowSupervisorComponent } from './components/workflow-supervisor/workflow-supervisor.component';
import { WorkflowVendorMissingBillsComponent } from './components/workflow-vendor-missing-bills/workflow-vendor-missing-bills.component';
import { UpdateVendorMissingBillStatusComponent } from './components/workflow-vendor-missing-bills/update-vendor-missing-bill-status/update-vendor-missing-bill-status.component';
import { WorkflowBoardHistoryComponent } from './components/workflow-board-history/workflow-board-history.component';
import { VendorMissingBillHistoryComponent } from './components/workflow-vendor-missing-bills/vendor-missing-bill-history/vendor-missing-bill-history.component';
import { WorkflowSupervisorConflictsComponent } from './components/workflow-supervisor/workflow-supervisor-conflicts/workflow-supervisor-conflicts.component';
import { WorkflowUserMetricsComponent } from './components/workflow-user-metrics/workflow-user-metrics.component';
import { WorkflowUserMetricsDetailComponent } from './components/workflow-user-metrics/workflow-user-metrics-detail/workflow-user-metrics-detail.component';
import { WorkflowReimbursementRequestComponent } from './components/workflow-reimbursement-request/workflow-reimbursement-request.component';
import { WorkflowReimbursementEditorComponent } from './components/workflow-reimbursement-request/workflow-reimbursement-editor/workflow-reimbursement-editor.component';
import { AttachReceiptComponent } from './components/workflow-reimbursement-request/workflow-reimbursement-editor/attach-receipt/attach-receipt.component';
import { WorkflowSubmittedInvoicesComponent } from './components/workflow-submitted-invoices/workflow-submitted-invoices.component';
import { WorkflowStepLineItemEditorComponent } from './components/workflow-step-line-item-editor/workflow-step-line-item-editor.component';
import { WorkflowCamEditorComponent } from './components/workflow-cam-editor/workflow-cam-editor.component';
import { WorkflowCamDenyComponent } from './components/workflow-cam-editor/workflow-cam-deny/workflow-cam-deny.component';
import { WorkflowAccountantEditorComponent } from './components/workflow-accountant-editor/workflow-accountant-editor.component';
import { WorkflowAcctStepDenyComponent } from './components/workflow-accountant-editor/workflow-acct-step-deny/workflow-acct-step-deny.component';
import { WorkflowStepReverseOrDeleteComponent } from './components/workflow-step-reverse-or-delete/workflow-step-reverse-or-delete.component';
import { WorkflowAcctStepUpdateInReviewComponent } from './components/workflow-accountant-editor/workflow-acct-step-update-in-review/workflow-acct-step-update-in-review.component';
import { WorkflowDeniedEditorComponent } from './components/workflow-denied-editor/workflow-denied-editor.component';
import { WorkflowApprovedStepComponent } from './components/workflow-approved-step/workflow-approved-step.component';
import { WorkflowWorkorderSelectorComponent } from './components/workflow-workorder-selector/workflow-workorder-selector.component';
import { WorkflowCommunityAttributionComponent } from './components/workflow-community-attribution/workflow-community-attribution.component';

// service imports
import { WorkflowDashboardService } from './_services/workflow-dashboard.service';
import { WorkflowPaymentRequestService } from '../workflow-payment-request-module/_services/workflow-payment-request.service';

@NgModule({
    declarations: [
        WorkflowEditorComponent,
        WorkflowDataEntryComponent,
        WorkflowDataEntryVendorNotesViewerComponent,
        WorkflowSearchComponent,
        ManageWorkflowVendorEditComponent,
        WorkflowVendorEditEditorComponent,
        WorkflowDeleteComponent,
        WorkflowQueueComponent,
        WorkflowQueueDataGridComponent,
        WorkflowDashboardComponent,
        WorkflowSupervisorComponent,
        WorkflowVendorMissingBillsComponent,
        UpdateVendorMissingBillStatusComponent,
        WorkflowBoardHistoryComponent,
        VendorMissingBillHistoryComponent,
        WorkflowSupervisorConflictsComponent,
        WorkflowUserMetricsComponent,
        WorkflowUserMetricsDetailComponent,
        WorkflowCamEditorComponent,
        WorkflowReimbursementRequestComponent,
        WorkflowReimbursementEditorComponent,
        AttachReceiptComponent,
        WorkflowSubmittedInvoicesComponent,
        WorkflowStepLineItemEditorComponent,
        WorkflowCamDenyComponent,
        WorkflowAccountantEditorComponent,
        WorkflowDeniedEditorComponent,
        WorkflowAcctStepDenyComponent,
        WorkflowAcctStepUpdateInReviewComponent,
        WorkflowStepReverseOrDeleteComponent,
        WorkflowApprovedStepComponent,
        WorkflowWorkorderSelectorComponent,
        WorkflowCommunityAttributionComponent
    ],
    imports: [
        CommonModule,
        DxBoxModule,
        DxLoadPanelModule,
        DxResponsiveBoxModule,
        DxDropDownBoxModule,
        DxDataGridModule,
        DxButtonModule,
        DxContextMenuModule,
        DxValidationGroupModule,
        DxValidatorModule,
        DxRadioGroupModule,
        DxTextBoxModule,
        DxTemplateModule,
        DxCheckBoxModule,
        DxDateBoxModule,
        DxSelectBoxModule,
        DxSwitchModule,
        DxPopupModule,
        DxScrollViewModule,
        DxNumberBoxModule,
        DxTextAreaModule,
        DxFileUploaderModule,
        DxDropDownButtonModule,
        DxFormModule,
        DxListModule,
        DxTooltipModule,
        DxChartModule,
        DxPopoverModule,
        DxTabsModule,
        DxTabPanelModule,
        DxToolbarModule,
        AngularSplitModule,
        CCCommonModule,
        CCDataGridFeaturesModule,
        ManagementCommonModule,
        VendorModule,
        SharedModule,
        SharedWorkflowModule,
        SharedCirabooksModule,
        SharedVendorManagementModule,
        WorkflowRoutingModule,
        WorkOrderMainModule,
        WorkflowPaymentRequestModule.forFeature(WorkflowPaymentRequestService)
    ],
    providers: [WorkflowDashboardService],
    exports: [
        WorkflowEditorComponent,
        WorkflowSearchComponent,
        WorkflowQueueDataGridComponent,
        WorkflowDashboardComponent,
        WorkflowBoardHistoryComponent,
        WorkflowSubmittedInvoicesComponent,
        WorkflowCommunityAttributionComponent
    ],
    entryComponents: [WorkflowDashboardComponent]
})
export class WorkflowModule {}
